// src/components/Pagination.js
// Shared Previous/Next pager for every admin table — page is 1-indexed throughout.
import React from "react";
import "./Pagination.css";

const Pagination = ({ page, perPage, total, onPageChange }) => {
  const totalPages = Math.max(1, Math.ceil(total / perPage));
  if (totalPages <= 1) return null;

  return (
    <div className="pagination">
      <button type="button" onClick={() => onPageChange(page - 1)} disabled={page <= 1}>
        ← Previous
      </button>
      <span className="pagination-status">
        Page {page} of {totalPages}
      </span>
      <button type="button" onClick={() => onPageChange(page + 1)} disabled={page >= totalPages}>
        Next →
      </button>
    </div>
  );
};

export default Pagination;
